import {
  CREATING_IADB_METADATA_REQUEST,
  CREATING_IADB_METADATA_REQUEST_SUCCEEDED,
  CREATING_IADB_METADATA_REQUEST_FAILED,
  FETCHING_IADB_METADATA_REQUEST,
  FETCHING_IADB_METADATA_REQUEST_SUCCEEDED,
  FETCHING_IADB_METADATA_REQUEST_FAILED,
  FETCHING_IADB_METADATA_LIST_REQUEST_REQUEST,
  FETCHING_IADB_METADATA_LIST_REQUEST_SUCCEEDED,
  FETCHING_IADB_METADATA_LIST_REQUEST_FAILED,
  UPDATING_IADB_METADATA_REQUEST,
  UPDATING_IADB_METADATA_SUCCEEDED,
  UPDATING_IADB_METADATA_FAILED,
  DELETING_IADB_METADATA_REQUEST,
  DELETING_IADB_METADATA_SUCCEEDED,
  DELETING_IADB_METADATA_FAILED,
} from "constants/actionTypes.jsx";

const initialState = {
  loading: false,  
  items: [],  
  error: null,
  createIADBMetadata: {
    creating: false,
    success: false,
    error: null,
  },
  fetchingIADBMetadata: {
    loading: false,
    success: false,
    error: null,
  },
  fetchingIADBMetadatas: {
    loading: false,
    success: false,
    error: null,
  },
  updateIADBMetadata: {
    updating: false,
    success: false,
    error: null,
  },
  deleteIADBMetadata: {
    deleting: false,
    success: false,
    error: null,
  },
};

function iadbReducer(state = initialState, action) {
  switch (action.type) {
    case CREATING_IADB_METADATA_REQUEST:
      return Object.assign({}, state, {
        ...state,
        createIADBMetadata: { creating: true, error: null }
      });

    case CREATING_IADB_METADATA_REQUEST_SUCCEEDED:
      var items = [...state.items];
      items = [...items, action.payload]
      return Object.assign({}, state, {
        ...state,
        items: items,
        createIADBMetadata: { creating: false, success: true, error: null },
      });

    case CREATING_IADB_METADATA_REQUEST_FAILED:
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";
      return Object.assign({}, state, {
        ...state,
        createIADBMetadata: { creating: false, success: false, error: error },
      });

    case FETCHING_IADB_METADATA_LIST_REQUEST_REQUEST:
      return Object.assign({}, state, {
        ...state,
        fetchingIADBMetadatas: { loading: true, error: null },
        loading: true,
        items: []
      });

    case FETCHING_IADB_METADATA_LIST_REQUEST_SUCCEEDED:
      var items = state.items;
      items = action.payload;
      return Object.assign({}, state, {
        ...state,
        fetchingIADBMetadatas: { loading: false, error: null },
        items: items,
        loading: false,
      });

    case FETCHING_IADB_METADATA_LIST_REQUEST_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";
      return Object.assign({}, state, {
        ...state,
        fetchingIADBMetadatas: { loading: false, error: error },
        loading: false,
        error: error,
        items: []
      });
    }

    case FETCHING_IADB_METADATA_REQUEST:
      return Object.assign({}, state, {
        ...state,
        fetchingIADBMetadata: { loading: true },
      });
    case FETCHING_IADB_METADATA_REQUEST_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        fetchingIADBMetadata: { loading: false, error: null },
      });
    case FETCHING_IADB_METADATA_REQUEST_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        fetchingIADBMetadata: {
          loading: false,
          error: error,
        },
      });
    }

    case UPDATING_IADB_METADATA_REQUEST:
      return Object.assign({}, state, {
        ...state,
        updateIADBMetadata: {
          updating: true,
        },
      });
    case UPDATING_IADB_METADATA_SUCCEEDED:
      var items = [...state.items];
      var index = items.findIndex(item => {
        return item.id === action.payload.id
      })
      items[index] = action.payload;
      return Object.assign({}, state, {
        ...state,
        items:items,
        updateIADBMetadata: { updating: false, success: true, error: null },
      });
    case UPDATING_IADB_METADATA_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        updateIADBMetadata: {
          updating: false,
          success: false,
          error: error,
        },
      });
    }

    case DELETING_IADB_METADATA_REQUEST:
      return Object.assign({}, state, {
        ...state,
        deleteIADBMetadata: { deleting: true },
      });
    case DELETING_IADB_METADATA_SUCCEEDED:
      var items = [...state.items];
      var index = items.findIndex((item) => {
        return item.id === action.payload.id;
      })
      items.splice(index,1);
      return Object.assign({}, state, {
        ...state,
        items:items,
        deleteIADBMetadata: {
          deleting: false,
          success: true,
          error: null,
        },
      });
    case DELETING_IADB_METADATA_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : "Unknown error";

      return Object.assign({}, state, {
        ...state,
        deleteIADBMetadata: {
          deleting: false,
          success: false,
          error: error,
        },
      });
    }

    default:
      return state;
  }
}

export { iadbReducer };
